export enum ThemesEnum {
  DARK = 'dark',
  LIGHT = 'light',
}

export enum DensityEnum {
  DEFAULT = '1',
  COMPACT = '4',
  SUPER_COMPACT = '5',
}
